import { render, staticRenderFns } from "./DesignerEditDialog.vue?vue&type=template&id=2e2e0945"
import script from "./DesignerEditDialog.vue?vue&type=script&lang=js"
export * from "./DesignerEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports